import axios from "axios"

export function getLooseItemStockListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/distributor/admin/api/v1/inventory/loose-item/stock-list`, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      dealer: parameters.dealer,
      code: parameters.code,
      filter: {
        search: parameters.filter.search,
        search_by: parameters.filter.search_by,
        located_at: parameters.filter.located_at,
        nodes: parameters.filter.nodes,
        products: parameters.filter.products,
        box: parameters.filter.box,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}